module.exports = __webpack_public_path__ + "static/media/pricing-right-image.d3090470.png";